import { observer } from 'mobx-react';
import { LoanFundingCard } from 'libs/feature-one-tool/src/components/common/PlatformCapitalProvider';

export const CapitalProviderInfo = observer(({ capitalProvider }) => (
  <LoanFundingCard
    value={capitalProvider ? `External ${capitalProvider}` : 'External Capital'}
  />
));
